import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { merge, Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from '../../../auth/services/auth.service';

@Directive({ selector: '[ifLoggedIn]' })
export class IfLoggedIn implements OnDestroy, OnInit {
    @Input() set ifLoggedIn(value: boolean) {
        this.updateView(value);
    }

    private _hasView = false;
    private _previousValue: boolean;
    private userUpdated$: Observable<string>;
    private idTokenUpdated$: Observable<string>;
    private subscription: Subscription;

    constructor(
        private _viewContainer: ViewContainerRef,
        private _template: TemplateRef<Object>,
        private _authService: AuthService
    ) {
        // if the id token or user gets updated, we need to re-evaluate
        this.idTokenUpdated$ = _authService.idTokenUpdated;
        this.userUpdated$ = _authService.userUpdated;
    }

    ngOnInit() {
        this.subscription = merge(this.idTokenUpdated$, this.userUpdated$)
            .pipe(filter(() => this._previousValue !== undefined))
            .subscribe(() => this.updateView(this._previousValue));
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    private updateView(value: boolean) {

        this._previousValue = value;
        const condition = value ? this._authService.hasApplicationAccess : ! this._authService.hasApplicationAccess;

        if (condition && !this._hasView) {
            this._hasView = true;
            this._viewContainer.createEmbeddedView(this._template);
        } else if (!condition && this._hasView) {
            this._hasView = false;
            this._viewContainer.clear();
        }
    }
}
